var map = {
	"./demos/basic/index.ts": 18382,
	"./demos/complex/index.ts": 22175,
	"./demos/nested/index.ts": 97171,
	"./demos/range/index.ts": 23587,
	"./demos/vertical/index.ts": 74236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78338;